import { render, staticRenderFns } from "./OrderCalendarFiltersChip.vue?vue&type=template&id=e6abb8f6&scoped=true&lang=pug&"
import script from "./OrderCalendarFiltersChip.vue?vue&type=script&lang=js&"
export * from "./OrderCalendarFiltersChip.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendarFiltersChip.vue?vue&type=style&index=0&id=e6abb8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6abb8f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer,VDivider,VIcon,VSpacer})
